import React from 'react'
import { Row, Col } from 'react-grid-system'
import { Message, Text, Heading, Image, Button } from 'components/library'
import './ContractSituationQuiz.css'

import ContractUavImage from 'assets/img/contract_uav.svg'
import ContractUavGcImage from 'assets/img/contract_uav_gc.svg'

const SituationBox = props => {
  return (
    <div className="Situation-container">
      <div className="Situation-box">
        <b>Situatie {props.num}</b> <br/>
        {props.children}
      </div>
    </div>
  )
}

class ContractSelectionBox extends React.Component {
  state = {
    hasAnswered: false
  }

  handleSelect = (e, givenAnswer) => {
    if (this.state.hasAnswered) {
      return
    }

    this.setState(prevState => {
      return {
        ...prevState,
        hasAnswered: true,
        answer: givenAnswer
      }
    })

    this.props.answerHandler(e, givenAnswer)
  }

  render () {
    const baseClassNames = ['Contract-container']
    if (this.state.hasAnswered) {
      baseClassNames.push('Has-selected')
    }

    const uavClassNames = ['Contract-item']
    if (this.state.answer === 'UAV') {
      uavClassNames.push('Is-selected')
    }

    const uavGcClassNames = ['Contract-item']
    if (this.state.answer === 'UAV-gc') {
      uavGcClassNames.push('Is-selected')
    }

    return (
      <div className={baseClassNames.join(' ')}>
        <Heading h3>{this.props.title}</Heading>
        Welke contractvorm is het meest geschikt voor dit project?

        <div className={uavClassNames.join(' ')} onClick={(e) => this.handleSelect(e, "UAV")}>
          <Image full src={ContractUavImage} />
        </div>

        <div className={uavGcClassNames.join(' ')} onClick={(e) => this.handleSelect(e, "UAV-gc")}>
          <Image full src={ContractUavGcImage} />
        </div>

      </div>
    )
  }
}

class ContractSituationQuiz extends React.Component {
  state = {
    activeQuiz: undefined,
    currentQuizIndex: undefined,
    quizStatus: {
      answered: false,
      correct: undefined
    }
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      activeQuiz: this.props.quizItems[0],
      currentQuizIndex: 0
    })
  }

  handleAnswer = (e, givenAnswer) => {
    let answerWasCorrect = false
    if (this.state.activeQuiz.correctAnswer === givenAnswer) {
      answerWasCorrect = true
    }

    this.setState(prevState => {
      return {
        ...prevState,
        quizStatus: {
          answered: true,
          correct: answerWasCorrect
        }
      }
    })
  }

  handleNewQuiz = e => {
    this.setState(prevState => {
      return {
        ...prevState,
        activeQuiz: this.props.quizItems[this.state.currentQuizIndex + 1],
        currentQuizIndex: this.state.currentQuizIndex + 1,
        quizStatus: {
          answered: false,
          correct: undefined
        }
      }
    })
  }

  render () {
    return (
      <div>

        {this.state.activeQuiz &&
        <Row>
          <Col sm={6}>
            <SituationBox num={this.state.activeQuiz.num}>
              <Text>{this.state.activeQuiz.situation}</Text>
            </SituationBox>
            <br/><br/>

            {(this.state.quizStatus.answered && this.state.currentQuizIndex < (this.props.quizItems.length - 1)) &&
            <Button onClick={this.handleNewQuiz} label="Volgende situatie" outline></Button>
            }

          </Col>

          <Col sm={6}>
            <ContractSelectionBox key={this.state.currentQuizIndex} answerHandler={this.handleAnswer} title={this.state.activeQuiz.title}></ContractSelectionBox>
          </Col>
        </Row>
        }

        {this.state.quizStatus.answered &&
        <Row>
          <Col sm={6}>

          </Col>
          <Col sm={6}>
            {this.state.quizStatus.correct &&
            <Message success>
              <b>Inderdaad, {this.state.activeQuiz.correctAnswer}!</b> <br/>
              <Text>
                {this.state.activeQuiz.msgCorrect}
              </Text>
            </Message>
            }

            {!this.state.quizStatus.correct &&
            <Message error>
              <b>Helaas, we kiezen in dit geval voor {this.state.activeQuiz.correctAnswer}!</b> <br/>
              <Text>
                {this.state.activeQuiz.msgIncorrect}
              </Text>
            </Message>
            }
          </Col>
        </Row>
        }
      </div>
      )
  }
}

export default ContractSituationQuiz


// WEBPACK FOOTER //
// ./src/components/library/contract_situation_quiz/ContractSituationQuiz.js